import { HeartIcon } from '@heroicons/react/24/solid';
import React, { useEffect, useState } from 'react';
import { PhotoProvider, PhotoView } from 'react-photo-view';

const PortfolioSection = () => {
    const [portfolios, setPortfolios] = useState([]);
    useEffect(() => {
        fetch('portfolio.json')
            .then(res => res.json())
            .then(data => setPortfolios(data))
    }, [])
    return (
        <div className="max-w-7xl mx-auto px-6 pts-20">
            <div className='text-center mb-20'>
                <h3 className="text-xs md:text-sm xl:text-md font-semibold  tracking-widest mb-4 text-[#ff014f] uppercase">VISIT MY PORTFOLIO AND KEEP YOUR FEEDBACK</h3>
                <h1 className='text-5xl md:text-6xl xl:text-7xl font-bold'>My Portfolio</h1>
            </div>

            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 mx-5'>

                {
                    portfolios.map(portfolio => <PhotoProvider key={portfolio.id}>
                        <div className="card w-full shadow-lg shadow-slate-600 rounded-lg ">
                            <figure className="px-10 pt-10">
                                <PhotoView src={portfolio.photo}>
                                    <img src={portfolio.photo} alt="Portfolio" style={{ objectFit: 'cover' }} className="rounded-xl h-72 w-full" />
                                </PhotoView>
                            </figure>
                            <div className="card-body">
                                <div className='flex'>
                                    <p className='text-[#ff014f]  cursor-pointer'>{portfolio.tech}</p>
                                    <div className='flex items-center gap-2'>
                                        <HeartIcon className='h-5 w-5 text-[#ff014f] '></HeartIcon>
                                        <p> {portfolio.react}</p>
                                    </div>
                                </div>
                                <a href={portfolio.link} target="_blank" rel="noreferrer"> <h2 className="text-2xl font-semibold hover:text-[#ff014f] cursor-pointer">{portfolio.name}</h2></a>

                            </div>
                        </div>
                    </PhotoProvider>)
                }
            </div>
            <div className="divider mt-20"></div>
        </div>
    );
};

export default PortfolioSection;